import { AbstractModel } from '.';
import Vue from 'vue';

class model extends AbstractModel {
    endpoint = 'gallery';

    getOrganizationImages(limit = -1) {
        const orderBy = [
            {
                field: 'ordering',
                direction: 'ASC',
                type: 'field',
            },
            {
                field: 'id',
                direction: 'DESC',
                type: 'field',
            },
        ];
        return this.get({
            params: {
                'order-by': orderBy,
                filter: [
                    {
                        field: 'active',
                        value: true,
                        type: 'eq',
                    },
                    {
                        field: 'organization',
                        value: Vue.$store.state.organization.selectedOrganizationID,
                        type: 'eq',
                    },
                ],
                'response-group': 'short',
                limit,
            },
        })
            .then(r => r.data)
            .then(images => {
                if (images.length < limit) {
                    const limitLeft = limit - images.length;
                    return this.get({
                        params: {
                            'order-by': orderBy,
                            filter: [
                                {
                                    type: 'andx',
                                    conditions: [
                                        {
                                            field: 'organization',
                                            type: 'isnull',
                                        },
                                        {
                                            field: 'participant',
                                            type: 'isnull',
                                        },
                                    ],
                                },
                            ],
                            'response-group': 'short',
                            limit: limitLeft,
                        },
                    })
                        .then(r => r.data)
                        .then(predefinedImages => {
                            return [...images, ...predefinedImages];
                        });
                } else {
                    return images;
                }
            });
    }
}

export const GalleryModel = new model();
